// extracted by mini-css-extract-plugin
export var button = "_f7-4";
export var hasDarkBackground = "_f7-7";
export var hasLightBackground = "_f7-6";
export var iconWrapper = "_f7-0";
export var large = "_f7-2";
export var medium = "_f7-1";
export var small = "_f7-5";
export var xsmall = "_f7-3";